export default __webpack_public_path__ + "static/media/paymentPage.83ab7dd9.webp";